export const DEFAULT_IMAGE_ICON_SIZE = 33;

export const THUMBNAIL_WIDTH = 60;

export const NUMBER_OF_OPTIONS_TO_SHOW_BEFORE_COLLAPSE = 1;
export const NUMBER_OF_PROJECTIONS_TO_SHOW_BEFORE_COLLAPSE = 2;
export const MAX_DESCRIPTION_LINE_LENGTH = 500;
export const MAX_MODIFIER_LENGTH = 485;

export const SPECS = {
  CheckoutExcludeGoogleAutoCompleteOld: 'specs.stores.CheckoutExcludeGoogleAutoComplete',
  CheckoutExcludeGoogleAutoComplete: 'specs.ecom.CheckoutExcludeGoogleAutoComplete',
  AddSlotToCheckoutPolicies: 'specs.stores.AddSlotToCheckoutPolicies',
  DeliverySectionCheckoutUseDeliverySolutions: 'specs.stores.DeliverySectionCheckoutUseDeliverySolutions',
  ShouldFixZoomForCheckoutInClassic: 'specs.stores.ShouldFixZoomForCheckoutInClassic',
  MakeGetPaymentDetailsIdSync: 'specs.ecom.MakeGetPaymentDetailsIdSync',
  FixPaymentRequestViewCss: 'specs.ecom.FixPaymentRequestViewCss',
  AlwaysSendCurrencyHeader: 'specs.ecom.AlwaysSendCurrencyHeader',
  SupportManualPaymentsOnPaymentRequest: 'specs.ecom.SupportManualPaymentsOnPaymentRequest',
  ShowVoidedErrorMessage: 'specs.ecom.ShowVoidedErrorMessage',
  HideMissingLineItemImagesInPaymentRequest: 'specs.ecom.HideMissingLineItemImagesInPaymentRequest',
  FixCheckoutPreSelectedEnabledDeliveryCountries: 'specs.ecom.FixCheckoutPreSelectedEnabledDeliveryCountries',
  PayLinkShowGetResolvedError: 'specs.ecom.PayLinkShowGetResolvedError',
  BISameAsDeliveryAddress: 'specs.ecom.BISameAsDeliveryAddress',
  ErrorHandlerOnStorefrontSdk: 'specs.ecom.ErrorHandlerOnStorefrontSdk',
  CheckoutSkipCustomerDetailstStep: 'specs.ecom.CheckoutSkipCustomerDetailstStep',
  UseLayoutEffectInCheckout: 'specs.ecom.UseLayoutEffectInCheckout',
  DontUseLineItemEnricherInCartAndCheckout: 'specs.ecom.DontUseLineItemEnricherInCartAndCheckout',
  MoveCheckoutToViewerContext: 'specs.ecom.MoveCheckoutToViewerContext',
  StopUsingPaymentMethodsInCart: 'specs.ecom.StopUsingPaymentMethodsInCart',
  RemoveSubscriptionObjectType: 'specs.ecom.RemoveSubscriptionObjectType',
  EnableConcatStreetAddress: 'specs.ecom.EnableConcatStreetAddress',
  MigrateAddressFormToV2: 'specs.ecom.MigrateAddressFormToV2',
  CallCartV2FromCheckout: 'specs.ecom.CallCartV2FromCheckout',
  AddCartServiceToContext: 'specs.ecom.AddCartServiceToContext',
  SupportTaxExemptionOnCheckout: 'specs.ecom.SupportTaxExemptionOnCheckout',
  UseLocalDatasetDirectlyInCheckout: 'specs.ecom.UseLocalDatasetDirectlyInCheckout',
  ExpressLoaderInCheckout: 'specs.ecom.ExpressLoaderInCheckout',
  MakeOnLoadWaitForLoaderToDisappearInExpress: 'specs.ecom.MakeOnLoadWaitForLoaderToDisappearInExpress',
  FixCheckoutPageSpecificStageExpanded: 'specs.ecom.FixCheckoutPageSpecificStageExpanded',
  ResetInitialStepOnInit: 'specs.ecom.ResetInitialStepOnInit',
  NavigateToTYPWhenHasOrderId: 'specs.ecom.NavigateToTYPWhenHasOrderId',
  FixCouponFocusMobileSummary: 'specs.ecom.FixCouponFocusMobileSummary',
  FetchCheckoutOnLogin: 'specs.ecom.FetchCheckoutOnLogin',
  DeliveryOptionsSetFirstAsDefault: 'specs.ecom.deliveryOptionsSetFirstAsDefault',
  UseMarketingConsentApiForSubscription: 'specs.ecom.UseMarketingConsentApiForSubscription',
  StopSendingOriginInCheckoutUrl: 'specs.ecom.StopSendingOriginInCheckoutUrl',
  UseEcommerceSettingsDeliveryCountries: 'specs.ecom.UseEcommerceSettingsDeliveryCountries',
  PickupOnlyFlow: 'specs.ecom.PickupOnlyFlow',
  SupportDynamicBillingFieldsCheckout: 'specs.ecom.SupportDynamicBillingFieldsCheckout',
  ShowFormsPerLineItemsStep: 'specs.ecom.ShowFormsPerLineItemsStep',
  InitFormsOnLoad: 'specs.ecom.InitFormsOnLoad',
  ShouldRenderStepContentWithCallback: 'specs.ecom.ShouldRenderStepContentWithCallback',
};

export const A11yIds = {
  SummarySection: 'summary-section',
};

export const MANDATORY_FIELDS_HIDDEN = [
  'countryCode',
  'state',
  'email',
  'firstName',
  'lastName',
  'street',
  'houseNumber',
  'address',
  'city',
  'zipCode',
  'phone',
];

export const HOLDER_ID_FIELD = 'holderId';
